var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((10),function(index){return _c('div',{key:index,staticClass:"gl-flex gl-items-center gl-gap-3"},[_c('div',{staticClass:"gl-animate-skeleton-loader gl-my-3 gl-h-7 gl-w-7 gl-shrink-0 gl-rounded-full"}),_vm._v(" "),_c('div',{staticClass:"gl-animate-skeleton-loader gl-my-3 gl-h-5 gl-w-75 gl-max-w-full gl-rounded-base"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }